// Configures the PDF.js web worker required by react-pdf. Must be imported
// once at the app entry point before any PDF rendering occurs. The worker is
// loaded from unpkg pinned to the exact pdfjs-dist version bundled with react-pdf
// to avoid version mismatches.
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
